import React from 'react';
import PropTypes from 'prop-types';
import RCSlider from 'rc-slider/lib/Slider';
import { is } from 'ramda';

import exists from 'lib/exists';

import classes from './Slider.less';
import Handle from './Handle';

const color = (clr, value) => (exists(clr) ? (is(Function, clr) ? clr(value) : clr) : null);

const Slider = ({
  value = null,
  onChange,
  minLabel,
  maxLabel,
  handleColor,
  trackColor,
  showTooltip = false,
  styleOverride,
  ...other
}) => (
  <div className={classes.sliderWrapper} style={styleOverride}>
    <RCSlider
      value={value}
      onChange={onChange}
      handle={Handle(handleColor, showTooltip)}
      trackStyle={{ backgroundColor: color(trackColor, value) }}
      {...other}
    />
    {(exists(minLabel) || exists(maxLabel)) && (
      <div className={classes.trackEndLabels}>
        <div className={classes.minLabel}>{minLabel || null}</div>
        <div className={classes.maxLabel}>{maxLabel || null}</div>
      </div>
    )}
  </div>
);

Slider.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  trackColor: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  handleColor: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  showTooltip: PropTypes.bool,
  styleOverride: PropTypes.object,
};

export default Slider;
